import {v4 as uuidv4} from 'uuid';
import {SearchMainVo} from '../../common/shared/api/nicolas/vo/SearchMainVo.interface';
import {SearchMain} from '../generated/types';
import {createSearchPopularKeywordRank} from './SearchRank';

export function createSearchMain({
  keyword_rank_list,
}: SearchMainVo): SearchMain {
  return {
    id: uuidv4(),
    keywordRankList: keyword_rank_list
      .slice(0, 10)
      .map(createSearchPopularKeywordRank),
  };
}
